import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { InsumoValidatePreviewContent } from './components/InsumoValidatePreviewContent';

export default function InsumoValidatePreview() {

    return (
        <MainContent component={<InsumoValidatePreviewContent />} titulo='Detalle del Insumo' tableMaxWidth />
    );

};